import { render } from "./App.vue?vue&type=template&id=9c94eec8&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=9c94eec8&scoped=true&lang=css"

import exportComponent from "E:\\Documents\\Github\\OpticTool\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c94eec8"]])

export default __exports__